// Generated by scripts/build-ui-icons.mjs.
export { HouseLine as default } from "../ui/glyphs-4";
